import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, Link} from "react-router-dom";
import {
  Slide,
  IconButton,
  ClickAwayListener,
  InputBase,
  Button,
  Grid,
  Container,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Tabs,
  Tab,
  Box,
  Modal,
  Divider,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Pagination,
  CircularProgress,
  
  Avatar,
  InputAdornment,
  Card,
  CardContent,

} from '@mui/material';

import PaginationItem from '@mui/material/PaginationItem';

import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { styled } from '@mui/material/styles';
import { Document, Page, pdfjs } from 'react-pdf';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import CustomComplete from '../components/customComplete/CustomComplete';
import CustomCompleteWorksheet from '../components/customComplete/CustomCompleteWorksheet';
import Iconify from '../components/iconify';
// import Upload from '../components/upload';   
import Scrollbar from '../components/scrollbar/Scrollbar';

import { Api, UploadFile } from '../webservices';
import Header from './Header'
import Footer from './Footer'

const ProductsDemo = () => {

  const navigate = useNavigate();

  return (
    <>

      {/* <Stack backgroundColor={'text.secondary'}>
        <Stack
          flexDirection={'row'}
          alignItems={'flex-end'}
          justifyContent={'space-between'}
          sx={{
            padding: 3, mt: 1.5, mb: 1.5,
            flexWrap: 'nowrap', alignItems: 'center'
          }}
        >
          <Stack flexDirection={'row'} gap={3} >
            <Typography color="white">
              Foxearch Icon
            </Typography>
            <Typography color="white" sx={{ ml: 11, cursor: 'pointer' }} onClick={() => navigate('/home')}>
              Home
            </Typography>
            <Typography color="white" sx={{ cursor: 'pointer' }} onClick={() => navigate('/contactUs')}>
              Contact Us
            </Typography>
          </Stack>

          <Stack
            flexDirection="row"
            gap={2}
            sx={{ flexWrap: 'nowrap', alignItems: 'center' }}
          >
            <Iconify icon="fontisto:world-o" width="2rem" color="white" sx={{ cursor: "pointer" }} />
            <Typography color="white" sx={{ cursor: "pointer", marginRight: 4 }} onClick={() => navigate('/login')}>Sign In</Typography>
            <Button
              sx={{
                backgroundColor: "white",
                '&:hover': {
                  backgroundColor: "white",
                }
              }}
            >
              Request Demo
            </Button>
          </Stack>
        </Stack>
        <Divider sx={{ borderColor: "white" }} />

        <Box
          sx={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            color: '#fff',
            py: 8,
            textAlign: 'center'
          }}
        >
          <Container>
            <Typography variant="h2" gutterBottom>
              Explore Our Product Demo
            </Typography>
            <Typography variant="h6">
              See how our products can transform your business!
            </Typography>
          </Container>
        </Box>

      </Stack>
      <Stack sx={{ backgroundColor: '#EAF1FE' }}>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mt: 5,
            mb: 6
          }}
        >
          <iframe
            width="75%"
            height="370"
            src="https://www.youtube.com/embed/dQw4w9WgXcQ"
            title="Product Demo Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ borderRadius: '11px' }}
          />
        </Box>
      </Stack>

      <Container sx={{ mt: 3 }}>
        <Typography variant="h4" gutterBottom>
          Key Features
        </Typography>
        <Typography variant="body1" paragraph>
          Our product is designed to offer exceptional performance and user experience. Discover the features that set us apart from the competition.
        </Typography>

        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={4}>
            <Card
              sx={{
                minHeight: '250px',
                boxShadow: 3,
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-10px)',
                  boxShadow: 6,
                },
              }}
            >
              <CardContent>
                <Typography variant="h6">Feature 1</Typography>
                <Typography variant="body2" color="textSecondary">
                  Description of Feature 1 goes here.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Card
              sx={{
                minHeight: '250px',
                boxShadow: 3,
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-10px)',
                  boxShadow: 6,
                },
              }}
            >
              <CardContent>
                <Typography variant="h6">Feature 2</Typography>
                <Typography variant="body2" color="textSecondary">
                  Description of Feature 2 goes here.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Card
              sx={{
                minHeight: '250px',
                boxShadow: 3,
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-10px)',
                  boxShadow: 6,
                },
              }}
            >
              <CardContent>
                <Typography variant="h6">Feature 3</Typography>
                <Typography variant="body2" color="textSecondary">
                  Description of Feature 3 goes here.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

      </Container>

      <Stack
        sx={{
          alignItems: 'center',
          py: 5,
          backgroundColor: '#003366',
          color: 'white',
          mt: 5,
        }}
      >
        <Typography variant="h4" gutterBottom>
          Ready to Experience It?
        </Typography>
        <Button
          variant="contained"
          sx={{
            backgroundColor: '#FF6600',
            '&:hover': { backgroundColor: '#E55D00' },
          }}
        // onClick={() => navigate('/contactUs')}
        >
          Request a Demo
        </Button>
      </Stack> */}

      <div id="body" className="page-template page-template-page-templates page-template-full-width page-template-page-templatesfull-width-php page page-id-1277 wp-custom-logo theme-deepdigital woocommerce-no-js tribe-no-js page-template-deepdigital yith-wcbm-theme-deepdigital singular no-sidebar container-1170 meta-icons-main woo header-sticky animation-enabled elementor-default elementor-kit-2882 elementor-page elementor-page-1277" itemType="https://schema.org/WebPage" itemScope="itemscope" data-animate='{&quot;.footer-widgets .widget&quot;:&quot;fadeInUp&quot;}'
      >

        <button id="login_modal_close" aria-controls="login_dropdown" className="nav-btn" aria-expanded="true" aria-label="Login Toggler" />

        {/* </button> */}
        <div id="box" className="box-fade-in">
          <div id="top-wrap">
            <Header />
            <section id="title" className="title title-3 text-center polygon l m fs-12 background-cover cover-center nw_tbar">
              <div className="container ">
                <h5 itemProp="headline" style={{ color: '#ed457a' }}>Product Demo
                </h5>
                <h6 style={{color:'#fff'}}>
                  <small>Unlock the potential of your recruitment process with Foxearch! Dive into our interactive product Demo</small>
                </h6>
                <nav className="breadcrumbs"><span><span><Link to = "/home">Home</Link></span> &bull; 
                <span className="breadcrumb_last" aria-current="page" style={{color:'#fff'}}>Poduct Demo</span></span>
                </nav> 
              </div>
            </section> 
          </div>
          <div data-elementor-type="wp-page" data-elementor-id="8199" className="elementor elementor-8199">
            <section className="elementor-section elementor-top-section elementor-element elementor-element-0532fa5 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="0532fa5" data-element_type="section">
              <div className="elementor-container elementor-column-gap-default">
                <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3cd85d3" data-id="3cd85d3" data-element_type="column">
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <section className="elementor-section elementor-inner-section elementor-element elementor-element-1da5947 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="1da5947" data-element_type="section">
                      <div className="elementor-container elementor-column-gap-default">
                        <iframe
                          width="75%"
                          height="370"
                          src="https://www.youtube.com/embed/dQw4w9WgXcQ"
                          title="Product Demo Video"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                          style={{ borderRadius: '11px' }}
                        />
                      </div>
                    </section>
                    {/* <section className="elementor-section elementor-inner-section elementor-element elementor-element-aa94572 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="aa94572" data-element_type="section">
                      <div className="elementor-container elementor-column-gap-default">
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-dabea77" data-id="dabea77" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-00b4f8e elementor-widget__width-initial elementor-widget elementor-widget-image" data-id="00b4f8e" data-element_type="widget" data-widget_type="image.default">
                              <div className="elementor-widget-container">
                                <img loading="lazy" decoding="async" width="60" height="58" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/info_icon_4.png" className="attachment-large size-large wp-image-8204" alt="" />													</div>
                            </div>
                            <div className="elementor-element elementor-element-789a0d4 elementor-widget elementor-widget-heading" data-id="789a0d4" data-element_type="widget" data-widget_type="heading.default">
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default"><a href="#">Product Designer</a></h2>		</div>
                            </div>
                            <div className="elementor-element elementor-element-71276c1 elementor-widget elementor-widget-text-editor" data-id="71276c1" data-element_type="widget" data-widget_type="text-editor.default">
                              <div className="elementor-widget-container">
                                Designer with 3 years’ experience in UX
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-8fd7f0b" data-id="8fd7f0b" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-898b9f9 elementor-widget__width-initial elementor-widget elementor-widget-image" data-id="898b9f9" data-element_type="widget" data-widget_type="image.default">
                              <div className="elementor-widget-container">
                                <img loading="lazy" decoding="async" width="54" height="53" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/info_icon_5.png" className="attachment-large size-large wp-image-8205" alt="" />													</div>
                            </div>
                            <div className="elementor-element elementor-element-6ae73ad elementor-widget elementor-widget-heading" data-id="6ae73ad" data-element_type="widget" data-widget_type="heading.default">
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default"><a href="#">Head of Marketing</a></h2>		</div>
                            </div>
                            <div className="elementor-element elementor-element-98faa8f elementor-widget elementor-widget-text-editor" data-id="98faa8f" data-element_type="widget" data-widget_type="text-editor.default">
                              <div className="elementor-widget-container">
                                Close-to-numbers individual with a passion for products
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-5cf1155" data-id="5cf1155" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-6843115 elementor-widget__width-initial elementor-widget elementor-widget-image" data-id="6843115" data-element_type="widget" data-widget_type="image.default">
                              <div className="elementor-widget-container">
                                <img loading="lazy" decoding="async" width="60" height="60" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/info_icon_6.png" className="attachment-large size-large wp-image-8206" alt="" />													</div>
                            </div>
                            <div className="elementor-element elementor-element-951fdd4 elementor-widget elementor-widget-heading" data-id="951fdd4" data-element_type="widget" data-widget_type="heading.default">
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default"><a href="#">Office Manager</a></h2>		</div>
                            </div>
                            <div className="elementor-element elementor-element-894a60e elementor-widget elementor-widget-text-editor" data-id="894a60e" data-element_type="widget" data-widget_type="text-editor.default">
                              <div className="elementor-widget-container">
                                A service-oriented go-getter with 3+ years’ experience						</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section> */}
                  </div>
                </div>
              </div>
            </section>


          </div>

          <div data-elementor-type="wp-page" data-elementor-id="1196" className="elementor elementor-1196">
            <section className="elementor-section elementor-top-section elementor-element elementor-element-fbf1854 elementor-section-full_width skew_top skew_bottom elementor-section-height-default elementor-section-height-default" data-id="fbf1854" data-element_type="section" data-settings="{&quot;background_background&quot;:&quot;classNameic&quot;}">
              <div className="elementor-container elementor-column-gap-default">
                <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ad805f1" data-id="ad805f1" data-element_type="column">
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div className="elementor-element elementor-element-206ddfc elementor-widget elementor-widget-image" data-id="206ddfc" data-element_type="widget" data-widget_type="image.default">
                      <div className="elementor-widget-container">
                        <img loading="lazy" decoding="async" width="4" height="134" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/white_line_big.png" className="attachment-full size-full wp-image-6727" alt="" />													</div>
                    </div>
                    <div className="elementor-element elementor-element-31dc388 elementor-widget elementor-widget-spacer" data-id="31dc388" data-element_type="widget" data-widget_type="spacer.default">
                      <div className="elementor-widget-container">
                        <div className="elementor-spacer">
                          <div className="elementor-spacer-inner" />
                        </div>
                      </div>
                    </div>
                    <section className="elementor-section elementor-inner-section elementor-element elementor-element-620c465 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="620c465" data-element_type="section">
                      <div className="elementor-container elementor-column-gap-default">
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-c09ff5c" data-id="c09ff5c" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-c178b12 elementor-widget elementor-widget-heading" data-id="c178b12" data-element_type="widget" data-widget_type="heading.default">
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default" style={{ color:'#ed457a'}}>01</h2>		</div>
                            </div>
                            <div className="elementor-element elementor-element-be5f8c4 elementor-absolute e-transform elementor-widget elementor-widget-heading" data-id="be5f8c4" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;,&quot;_transform_translateY_effect&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:-50,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_tablet&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_mobile&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_widescreen&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_widescreen&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="heading.default">
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default">Smart Worksheets </h2>		</div>
                            </div>
                          </div>
                        </div>
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-b855771" data-id="b855771" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-65558ee elementor-widget elementor-widget-image" data-id="65558ee" data-element_type="widget" data-widget_type="image.default">
                              <div className="elementor-widget-container">
                                <img loading="lazy" decoding="async" width="800" height="800" src="./assets/images/home/smartSheet.jpg" className="attachment-deepdigital-square size-deepdigital-square wp-image-6060" alt="" srcSet="./assets/images/home/smartSheet.jpg 800w, ./assets/images/home/smartSheet.jpg 150w" sizes="(max-width: 800px) 100vw, 800px" />													</div>
                            </div>
                            <div className="elementor-element elementor-element-63fc73d elementor-widget__width-initial elementor-absolute elementor-hidden-tablet elementor-hidden-mobile elementor-widget elementor-widget-image" data-id="63fc73d" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;}" data-widget_type="image.default">
                              <div className="elementor-widget-container">
                                <img loading="lazy" decoding="async" width="34" height="136" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/right_arrow.png" className="attachment-full size-full wp-image-6486" alt="" />													</div>
                            </div>
                          </div>
                        </div>
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-7956153" data-id="7956153" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-3e69246 elementor-widget elementor-widget-text-editor" data-id="3e69246" data-element_type="widget" data-widget_type="text-editor.default">
                              <div className="elementor-widget-container">
                                Foxearch's Smart Worksheets (Sales / Recruitment / Bench) are designed to eliminate redundancies and streamline workflows across Sales, Recruitment, and Bench processes.
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </section>
                    <div className="elementor-element elementor-element-e3c9920 elementor-widget elementor-widget-spacer" data-id="e3c9920" data-element_type="widget" data-widget_type="spacer.default">
                      <div className="elementor-widget-container">
                        <div className="elementor-spacer">
                          <div className="elementor-spacer-inner" />
                        </div>
                      </div>
                    </div>
                    <section className="elementor-section elementor-inner-section elementor-element elementor-element-5888b09 elementor-reverse-mobile elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="5888b09" data-element_type="section">
                      <div className="elementor-container elementor-column-gap-default">
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-035c8fd" data-id="035c8fd" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-547b92d elementor-widget elementor-widget-text-editor" data-id="547b92d" data-element_type="widget" data-widget_type="text-editor.default">
                              <div className="elementor-widget-container">
                                Foxearch leverages advanced AI technology to match candidates to jobs automatically, saving recruiters valuable time and effort.
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-d7e39ab" data-id="d7e39ab" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-38b77ba elementor-widget elementor-widget-image" data-id="38b77ba" data-element_type="widget" data-widget_type="image.default">
                              <div className="elementor-widget-container">
                                <img loading="lazy" decoding="async" width="800" height="800" src="./assets/images/home/vms_crm-.png" className="attachment-deepdigital-square size-deepdigital-square wp-image-6076" alt="" srcSet="./assets/images/home/vms_crm-.png 800w, ./assets/images/home/vms_crm-.png 150w" sizes="(max-width: 800px) 100vw, 800px" />													</div>
                            </div>
                            <div className="elementor-element elementor-element-4740162 elementor-widget__width-initial elementor-absolute elementor-hidden-tablet elementor-hidden-mobile elementor-widget elementor-widget-image" data-id="4740162" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;}" data-widget_type="image.default">
                              <div className="elementor-widget-container">
                                <img loading="lazy" decoding="async" width="34" height="136" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/left_arrow.png" className="attachment-full size-full wp-image-6734" alt="" />													</div>
                            </div>
                          </div>
                        </div>
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-753eee0" data-id="753eee0" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-b181133 elementor-widget elementor-widget-heading" data-id="b181133" data-element_type="widget" data-widget_type="heading.default">
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default">02</h2>		</div>
                            </div>
                            <div className="elementor-element elementor-element-3a90c5f elementor-absolute e-transform elementor-widget elementor-widget-heading" data-id="3a90c5f" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;,&quot;_transform_translateY_effect&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:-50,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_tablet&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_mobile&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_widescreen&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_widescreen&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="heading.default">
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default">AI-Powered Mapping</h2>		</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    <div className="elementor-element elementor-element-4cc7a89 elementor-widget elementor-widget-spacer" data-id="4cc7a89" data-element_type="widget" data-widget_type="spacer.default">
                      <div className="elementor-widget-container">
                        <div className="elementor-spacer">
                          <div className="elementor-spacer-inner" />
                        </div>
                      </div>
                    </div>
                    <section className="elementor-section elementor-inner-section elementor-element elementor-element-ad03e3d elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="ad03e3d" data-element_type="section">
                      <div className="elementor-container elementor-column-gap-default">
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-51a0b3d" data-id="51a0b3d" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-e2d6b63 elementor-widget elementor-widget-heading" data-id="e2d6b63" data-element_type="widget" data-widget_type="heading.default">
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default">03</h2>		</div>
                            </div>
                            <div className="elementor-element elementor-element-0b97037 elementor-absolute e-transform elementor-widget elementor-widget-heading" data-id="0b97037" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;,&quot;_transform_translateY_effect&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:-50,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_tablet&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_mobile&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_widescreen&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_widescreen&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="heading.default">
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default">Dashboard</h2>		</div>
                            </div>
                          </div>
                        </div>
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-79949d2" data-id="79949d2" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-17fce4c elementor-widget elementor-widget-image" data-id="17fce4c" data-element_type="widget" data-widget_type="image.default">
                              <div className="elementor-widget-container">
                                <img loading="lazy" decoding="async" width="800" height="800" src="./assets/images/home/dashboard.png" className="attachment-deepdigital-square size-deepdigital-square wp-image-6077" alt="" srcSet="./assets/images/home/dashboard.png 800w, ./assets/images/home/dashboard.png 150w" sizes="(max-width: 800px) 100vw, 800px" />													</div>
                            </div>
                            <div className="elementor-element elementor-element-3d3bf52 elementor-widget__width-initial elementor-absolute elementor-hidden-tablet elementor-hidden-mobile elementor-widget elementor-widget-image" data-id="3d3bf52" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;}" data-widget_type="image.default">
                              <div className="elementor-widget-container">
                                <img loading="lazy" decoding="async" width="34" height="136" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/right_arrow.png" className="attachment-full size-full wp-image-6486" alt="" />													</div>
                            </div>
                          </div>
                        </div>
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-9bcffbe" data-id="9bcffbe" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-1ad2d72 elementor-widget elementor-widget-text-editor" data-id="1ad2d72" data-element_type="widget" data-widget_type="text-editor.default">
                              <div className="elementor-widget-container">
                                Foxearch's dashboards provide a comprehensive view of real-time activities, performance metrics, and resource management.

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    <div className="elementor-element elementor-element-8183af5 elementor-widget elementor-widget-spacer" data-id="8183af5" data-element_type="widget" data-widget_type="spacer.default">
                      <div className="elementor-widget-container">
                        <div className="elementor-spacer">
                          <div className="elementor-spacer-inner" />
                        </div>
                      </div>
                    </div>
                    <section className="elementor-section elementor-inner-section elementor-element elementor-element-60f2912 elementor-reverse-mobile elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="60f2912" data-element_type="section">
                      <div className="elementor-container elementor-column-gap-default">
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-f49586c" data-id="f49586c" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-b0cace4 elementor-widget elementor-widget-text-editor" data-id="b0cace4" data-element_type="widget" data-widget_type="text-editor.default">
                              <div className="elementor-widget-container">
                                Foxearch provides access to an extensive multi-domain candidate database network that caters to diverse industries
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-ca672f1" data-id="ca672f1" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-a7b6a3b elementor-widget elementor-widget-image" data-id="a7b6a3b" data-element_type="widget" data-widget_type="image.default">
                              <div className="elementor-widget-container">
                                <img loading="lazy" decoding="async" width="800" height="800" src="./assets/images/home/network.jpg" className="attachment-deepdigital-square size-deepdigital-square wp-image-6076" alt="" srcSet="./assets/images/home/network.jpg 800w, ./assets/images/home/network.jpg 150w" sizes="(max-width: 800px) 100vw, 800px" />													</div>
                            </div>
                          </div>
                        </div>
                        <div className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-85abcdd" data-id="85abcdd" data-element_type="column">
                          <div className="elementor-widget-wrap elementor-element-populated">
                            <div className="elementor-element elementor-element-e105df8 elementor-widget elementor-widget-heading" data-id="e105df8" data-element_type="widget" data-widget_type="heading.default">
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default">04</h2>		</div>
                            </div>
                            <div className="elementor-element elementor-element-08cdc2d elementor-absolute e-transform elementor-widget elementor-widget-heading" data-id="08cdc2d" data-element_type="widget" data-settings="{&quot;_position&quot;:&quot;absolute&quot;,&quot;_transform_translateY_effect&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:-50,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_tablet&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_mobile&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_widescreen&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateX_effect_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]},&quot;_transform_translateY_effect_widescreen&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:&quot;&quot;,&quot;sizes&quot;:[]}}" data-widget_type="heading.default">
                              <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default">Foxearch Network</h2>		</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                    <div className="elementor-element elementor-element-b36bb1f elementor-widget elementor-widget-spacer" data-id="b36bb1f" data-element_type="widget" data-widget_type="spacer.default">
                      <div className="elementor-widget-container">
                        <div className="elementor-spacer">
                          <div className="elementor-spacer-inner" />
                        </div>
                      </div>
                    </div>
                    <div className="elementor-element elementor-element-d7c9b8f elementor-widget elementor-widget-image" data-id="d7c9b8f" data-element_type="widget" data-widget_type="image.default">
                      <div className="elementor-widget-container">
                        <img loading="lazy" decoding="async" width="4" height="94" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/vertical_line2.png" className="attachment-full size-full wp-image-6055" alt="" />													</div>
                    </div>
                    <div className="elementor-element elementor-element-c7d4fef elementor-widget elementor-widget-spacer" data-id="c7d4fef" data-element_type="widget" data-widget_type="spacer.default">
                      <div className="elementor-widget-container">
                        <div className="elementor-spacer">
                          <div className="elementor-spacer-inner" />
                        </div>
                      </div>
                    </div>
                    <div className="elementor-element elementor-element-dff18e4 elementor-align-center elementor-widget elementor-widget-button" data-id="dff18e4" data-element_type="widget" data-widget_type="button.default">
                      <div className="elementor-widget-container">
                        <div className="elementor-button-wrapper">
                          <a className="elementor-button elementor-button-link elementor-size-sm" href="/login">
                            <span className="elementor-button-content-wrapper">
                              <span className="elementor-button-text">Get Started</span>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="elementor-section elementor-top-section elementor-element elementor-element-0041dc1 elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="0041dc1" data-element_type="section">
              <div className="elementor-container elementor-column-gap-default">
                <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-3451e7b" data-id="3451e7b" data-element_type="column">
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div className="elementor-element elementor-element-2df1355 members-defaults-yes members-defaults-hover-background-yes elementor-widget elementor-widget-team-slider" data-id="2df1355" data-element_type="widget" data-widget_type="team-slider.default">
                      <div className="elementor-widget-container">
                        <div className="flexslider-container mwt-team-slider-container">
                          <h3 className="slider-title mwt-elementor-team-slider-title">team</h3>
                          <div className="flexslider team-slider" data-slideshow="1" data-slideshowspeed="3000" data-animation="fade">
                          <img decoding="async" className="swiper-slide-image" src="./assets/images/home/team_slide_01.jpg" alt="team_slide_01" />
                          </div>
                          <div className="flexslider-controls">
                            <ul className="flex-control-nav-1">
                              {/* <li className="menu__item">
                              <span className="mwt-elementor-team-slider-name">
                                Letha L. Young                            </span>
                              <span className="mwt-elementor-team-slider-position">
                                Marketer                            </span>
                            </li>
                            <li className="menu__item">
                              <span className="mwt-elementor-team-slider-name">
                                Harold D. Cote                            </span>
                              <span className="mwt-elementor-team-slider-position">
                                Developer                            </span>
                            </li>
                            <li className="menu__item">
                              <span className="mwt-elementor-team-slider-name">
                                Oren R. Odom                            </span>
                              <span className="mwt-elementor-team-slider-position">
                                Marketer                            </span>
                            </li> */}
                              <li className="menu__item">

                                <div className="elementor-element elementor-element-038afb3 elementor-widget elementor-widget-heading" data-id="038afb3" data-element_type="widget" data-widget_type="heading.default">
                                  <div className="elementor-widget-container">
                                    <h2 className="elementor-heading-title elementor-size-default" style={{color: '#3C6BA5'}}>
                                      Comprehensive Solutions for Every Function: <br />
                                       Recruitment, Sales & Management</h2>
                                  </div>
                                </div>

                                <br />
                                <p className='dmo_p'>We have you covered! Whether your focus is on recruitment, management, or sales,
                                our platform seamlessly integrates all your functions in one place. Introducing our innovative Smart Worksheets,
                                meticulously designed for professionals across various domains, including Recruitment, Sales,
                                Bench Sales, and Management. Say goodbye to the chaos of scattered data sources and the frustration of
                                searching for solutions. With Foxearch, you can effortlessly work, track, and manage all
                                your activities in a single, user-friendly interface. Experience enhanced productivity and streamlined processes
                                like never before!</p>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

        </div>
        <Footer />
        <a id="to-top" href="#body">
          <span className="screen-reader-text">
            Go to top		</span>
        </a>

      </div>
    </>
  );
};

export default ProductsDemo;
